import { render, staticRenderFns } from "./astuces-pour-reduire-le-cout-par-clic-cpc-sur-google-ads-sans-sacrifier-la-qualite.vue?vue&type=template&id=0ed67d3d&"
import script from "./astuces-pour-reduire-le-cout-par-clic-cpc-sur-google-ads-sans-sacrifier-la-qualite.vue?vue&type=script&lang=js&"
export * from "./astuces-pour-reduire-le-cout-par-clic-cpc-sur-google-ads-sans-sacrifier-la-qualite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports